import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { RotateCcw, Save } from "lucide-react";
import { SectionCard } from "@/components/common";
import { Button } from "@/components/ui";

interface ProfileSectionCardProps {
  anchorId: string;
  title: string;
  icon?: LucideIcon;
  modified: boolean;
  isSaving: boolean;
  onSave: () => void;
  onRevert: () => void;
  children: ReactNode;
}

export function ProfileSectionCard({
  anchorId,
  title,
  icon,
  modified,
  isSaving,
  onSave,
  onRevert,
  children,
}: ProfileSectionCardProps) {
  const { t } = useTranslation("settings");

  return (
    <SectionCard
      title={title}
      icon={icon}
      id={anchorId}
      modified={modified}
      className="scroll-mt-24"
      footer={
        modified ? (
          <div className="flex flex-wrap justify-end gap-2 border-t border-surface-200 bg-surface-50/80 px-5 py-3">
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={onRevert}
              disabled={isSaving}
              leftIcon={<RotateCcw className="h-4 w-4" />}
            >
              {t("revertSection")}
            </Button>
            <Button
              type="button"
              size="sm"
              onClick={onSave}
              isLoading={isSaving}
              leftIcon={<Save className="h-4 w-4" />}
            >
              {t("saveSection")}
            </Button>
          </div>
        ) : undefined
      }
    >
      {children}
    </SectionCard>
  );
}
